import HTTP from '../script/service';
import Util from '../script/util';
import store from '../store/store';
import { message } from 'antd';

const ERTC = (window,
function () {
  const that = {
    isAgoraRTC: false, // 是否是声网
    token: null,
    client: null,
    joined: false,
    published: false,
    localStream: null,
    remoteStreams: [],
    params: {},
    device_list: [],
    mic_list: [],
    liveConfig: {},
    audioVolume: 100, //伴奏音量
    playVolume: 100, //扬声器音量
    speakVolume: 255, //麦克风音量
    disAudio: false, //是否被静音
  };
  that.openConn = function (room) {
    that.room = room;
    that.liveConfig = room.liveConfig || {};
    if (!that.client) {
      initClient().then(() => {
        that.room.events['RTC_INIT_END'] &&
          that.room.events['RTC_INIT_END'](that);
      });
    } else {
      that.room.events['RTC_INIT_END'] &&
        that.room.events['RTC_INIT_END'](that);
      setSysConfig();
      joinChannel();
    }
    return that;
  };
  //实例化客户端
  function initClient() {
    return new Promise((resolve) => {
      that.remoteStreams = [];
      that.default_mic = null;
      that.default_div = null;
      that.audio_state = false; //伴奏状态
      that.dev_state = true; //扬声器状态
      that.mic_state = true; //麦克风状态
      that.disAudio = false; //是否被静音
      that.wifiDown = document.getElementById('wifi-down');
      that.wifiUp = document.getElementById('wifi-up');
      const { rootConfig } = store.getState();
      window.eleEvents.openConn(rootConfig.agoraAppID).then(
        function (res) {
          that.client = true;
          that.isAgoraRTC = true;
          setSysConfig();
          bindEvent();
          getDevices().then(joinChannel);
          resolve();
        },
        function (res) {
          that.client = false;
          that.isAgoraRTC = false;
          message.error(res.message);
          resolve();
        }
      );
    });
  }
  //基础设置
  function setSysConfig() {
    //音质设置 统一使用高音质
    window.eleEvents.changeMusicHeight(5, 3); //高清
    // window.eleEvents.changeMusicHeight(0, 0); //默认
    window.eleEvents.setAudioHeight('HEAAC_2ch');
    window.eleEvents.change3AState({ aec: true, bs: true, agc: true });
  }
  function bindEvent() {
    //提示频道内谁在说话以及说话者音量的回调。
    window.eleEvents.bindEvent('groupAudioVolumeIndication', function (attr) {
      let speakMembers = {};
      attr.forEach((item) => {
        if (item.uid == 0) {
          item.uid = that.room.uid;
        }
        if (item.volume > 10) speakMembers[item.uid.toString()] = item.volume;
      });
      if (that.room.hasLive()) {
        that.room.showSpeakUsers(speakMembers);
      }
    });
    //加入频道
    window.eleEvents.bindEvent(
      '_web_joinedChannel',
      function (channel, uid, elapsed) {
        if (!that.room.conn) {
          that.destroyRoom(3);
        } else {
          that.delToMic(2);
        }
      }
    );
    //离开频道
    window.eleEvents.bindEvent('_web_leaveChannel', function (stats) {
      // console.log('_web_leaveChannel：', stats)
    });
    //网络连接状态已改变
    window.eleEvents.bindEvent(
      '_web_connectionStateChanged',
      function (state, reason) {
        // console.log('_web_connectionStateChanged：', stateMsgArr[state], reasonMsgArr[reason]);
      }
    );
  }
  //加入频道
  function joinChannel() {
    HTTP._get_agora_token({
      uid: that.room.uid || 0,
      channelName: that.room.roomid,
    }).then(async function (res) {
      if (res?.code === 200) {
        const data = res.data;
        setDefaultDevices();
        const {
          audioVolume,
          playVolume,
          speakVolume,
          default_div,
          default_mic,
        } = that;
        that.joinParam = {
          ...data,
          audioVolume,
          playVolume,
          speakVolume,
          default_div,
          default_mic,
        };
        window.eleEvents.joinChannel(that.joinParam).then(
          function (res) {
            that.joined = true;
            that.dev_state = true;
            //默认开启扬声器
            that.room.events['CHANGE_DEV_STATE'] &&
              that.room.events['CHANGE_DEV_STATE'](true, that.playVolume);
          },
          function (error) {
            message.error(error.message);
          }
        );
      } else {
        message.error(res.message);
      }
    });
  }
  //获取设备
  function getDevices() {
    return new Promise(function (resolve, reject) {
      window.eleEvents.getDevices().then(function (result) {
        that.mic_list = [...result.mic_devices];
        that.device_list = [...result.speak_devices];
        resolve();
      });
    });
  }
  //设置默认设备
  function setDefaultDevices() {
    that.audioVolume = 100;
    that.playVolume = 100;
    that.speakVolume = 255;
    that.audioModal = 1;
    //伴奏音量
    let audioVolume = Util.readCookie('audioVolume');
    if (audioVolume && !isNaN(audioVolume)) {
      that.audioVolume = parseInt(audioVolume);
    }
    //扬声器音量
    let playVolume = Util.readCookie('playVolume');
    if (playVolume && !isNaN(playVolume)) {
      that.playVolume = parseInt(playVolume);
    }
    //麦克风音量
    let speakVolume = Util.readCookie('speakVolume');
    if (speakVolume && !isNaN(speakVolume)) {
      that.speakVolume = parseInt(speakVolume);
    }
    //播放器模式
    let audioModal = Util.readCookie('audioModal');
    if (audioModal && !isNaN(audioModal)) {
      that.audioModal = parseInt(audioModal);
    }
    //设置默认设备
    let def_d = Util.readCookie('default_div_electron');
    if (def_d) {
      that.default_div = JSON.parse(def_d);
    } else {
      that.default_div = that.device_list[0];
    }
    let def_m = Util.readCookie('default_mic_electron');
    if (def_m) {
      that.default_mic = JSON.parse(def_m);
    } else {
      that.default_mic = that.mic_list[0];
    }
    if (that.room.events['INIT_DEFAULT_PARAM']) {
      that.room.events['INIT_DEFAULT_PARAM']({
        audioVolume: that.audioVolume,
        playVolume: that.playVolume,
        speakVolume: that.speakVolume,
      });
    }
  }
  //更新直播队列
  function getLiveConfig() {
    return new Promise((resolve, reject) => {
      //直播上报
      HTTP._mixed_channel_create({
        uid: that.room.uid,
        roomid: that.room.roomid,
        roomcid: that.room.roomid,
        creator: that.room.account,
      });
      const { rootConfig } = store.getState();
      //如果直播已经存在
      if (that.room.hasLive()) {
        that.liveConfig = {
          channelName: that.room.roomid, //房间名称
          channelId: null, //通话渠道 由网易返回
          creator: that.room.account, //直播创建者
          cid: null, //通话cid标识 由接口返回
          pushUrl: null, //推流地址
          rtmpPullUrl: null, //拉流地址
          web_version: rootConfig.version, //网页独有版本参数
          pc_version: that.room.base.clientInfo.version, //pc独有版本参数
          master_type: that.room.base.client, //主播当前终端类型
          config: [...that.room.liveConfig.config], //麦位属性配置
        };
      } else {
        that.liveConfig = {
          channelName: that.room.roomid, //房间名称
          channelId: null, //通话渠道 由网易返回
          creator: that.room.account, //直播创建者
          cid: null, //通话cid标识 由接口返回
          pushUrl: null, //推流地址
          rtmpPullUrl: null, //拉流地址
          web_version: rootConfig.version, //网页独有版本参数
          pc_version: that.room.base.clientInfo.version, //pc独有版本参数
          master_type: that.room.base.client, //主播当前终端类型
          config: [], //麦位属性配置
        };
        for (let i = 0; i < 9; i++) {
          that.liveConfig.config.push({
            index: i, //麦位
            type: i == 0 ? 0 : 1, //类型  0 主播位置 1 互动位  2 老板位
            enabled: true, // 是否启用用位置
            microphone: true, // 是否启用麦克风
            disAudio: false, //是否被静音
          });
        }
      }
      //2、发送麦位配置
      that.room.modifyConfig(that.liveConfig, false, function () {
        //3、发送1-1指令
        that.room.sendCustomMsg({
          action: '1-1',
          creator: that.room.account,
        });
        resolve();
      });
    });
  }
  //成功上麦
  function joinSuccess(callback) {
    that.published = true;
    that.room.queuePoll(`queue_${that.room.uid}`);
    //如果当前在相亲模式-并且游戏进行中, 用户需要上报
    if (
      that.room.roomInfo &&
      that.room.roomInfo.custom &&
      that.room.roomInfo.custom.rmode == 1 &&
      that.room.datingData &&
      that.room.datingData.sdata
    ) {
      HTTP._addDataingUser({
        roomid: that.room.roomid,
        uids: that.room.uid,
      });
    }
    //派单房, 用户需要上报 todo 2.21.3 更改为所有房间都上报
    // if (that.room.roomInfo && that.room.roomInfo.custom && that.room.roomInfo.custom.rmode == 6 && that.room.sendOrders && that.room.sendOrders.msgId) {
    if (that.room.base.microType === 0) {
      if (that.room.roomInfo && that.room.roomInfo.custom) {
        let meque = that.room.queueObject[that.room.account];
        let msgId = null;
        if (
          that.room.roomInfo.custom.rmode == 6 &&
          that.room.sendOrders &&
          that.room.sendOrders.msgId
        ) {
          msgId = that.room.sendOrders.msgId;
        }
        if (meque) {
          HTTP._oneorder_upMicrophone({
            uid: that.room.uid,
            roomId: that.room.roomid,
            index: meque.index,
            msgId,
          });
        }
      }
    }
    callback && callback();
  }
  //开启本地扬声器设备
  that.changeVoiceState = function ({ open, operateSource = false }) {
    if (that.isGameing && that.isGameOperateSpeaker && !operateSource && open) {
      message.warning('游戏中不允许切换麦克风状态');
      return false;
    }
    that.isGameOperateSpeaker = operateSource;
    that.dev_state = open;
    window.eleEvents.muteAllRemoteAudioStreams(open).then(
      function () {
        that.room.events['CHANGE_DEV_STATE'] &&
          that.room.events['CHANGE_DEV_STATE'](open, that.playVolume);
      },
      function (err) {
        message.error(err.message);
      }
    );
  };
  //开启本地麦克风设备
  that.changeMicState = function ({ open, operateSource = false }) {
    if (that.isGameing && that.isGameOperateMic && !operateSource && open) {
      message.warning('游戏中不允许切换麦克风状态');
      return false;
    }
    that.isGameOperateMic = operateSource;
    that.mic_state = open;
    window.eleEvents.muteLocalAudioStream(open).then(
      function () {
        that.room.events['CHANGE_MIC_STATE'] &&
          that.room.events['CHANGE_MIC_STATE'](open, that.speakVolume);
      },
      function (err) {
        message.error(err.message);
      }
    );
  };
  //开始第三方混音
  that.changeAudioState = function (open, clientPath, successBack, errorBack) {
    window.eleEvents.handleAudioHook(open, clientPath).then(
      function (res) {
        successBack && successBack(res);
      },
      function (error) {
        message.error(error.message);
        errorBack && errorBack(error);
      }
    );
  };
  //切换扬声器
  that.changeVoiceValue = function (dev) {
    if (that.isGameing && that.isGameOperateSpeaker) {
      message.warning('游戏中无法切换扬声器');
      return;
    }

    that.default_div = dev;
    that.dev_state = true;
    window.eleEvents.setAudioPlaybackDevice(dev).then(
      function () {
        Util.setCookie(
          'default_div_electron',
          JSON.stringify(that.default_div)
        );
        that.room.events['CHANGE_DEV_STATE'] &&
          that.room.events['CHANGE_DEV_STATE'](true, that.playVolume);
      },
      function (err) {
        message.error(err.message);
      }
    );
  };
  //切换麦克风
  that.changeVoiceSpeak = function (mic) {
    if (that.isGameing && that.isGameOperateMic) {
      message.warning('游戏中无法切换麦克风');
      return;
    }

    that.default_mic = mic;
    that.mic_state = true;
    window.eleEvents.setAudioRecordingDevice(mic).then(
      function () {
        Util.setCookie(
          'default_mic_electron',
          JSON.stringify(that.default_mic)
        );
        that.room.events['CHANGE_MIC_STATE'] &&
          that.room.events['CHANGE_MIC_STATE'](true, that.speakVolume);
      },
      function (err) {
        message.error(err.message);
      }
    );
  };
  //设置伴奏音量
  that.setAudioVolume = function (volume) {
    that.audioVolume = volume;
    Util.setCookie('audioVolume', volume);
    window.eleEvents.adjustAudioMixingVolume(volume);
  };
  //设置伴奏模式
  that.changePlayModel = function (m) {
    that.audioModal = m;
    Util.setCookie('audioModal', m);
  };
  //设置伴奏播放音量
  that.changeAudioMute = function (n) {
    window.eleEvents.adjustAudioMixingVolume(n ? 0 : that.audioVolume);
  };
  //设置扬声器音量
  that.setPlayVolume = function (volume, callback = null) {
    if (that.isGameing && that.isGameOperateSpeaker) {
      message.warning('游戏中无法调节扬声器音量');
      callback && callback(false);
      return;
    }
    that.dev_state = true;
    that.playVolume = volume;
    Util.setCookie('playVolume', volume);
    window.eleEvents.setAudioPlaybackVolume(volume);
    callback && callback(true);
  };
  //设置麦克风音量
  that.setSpeakVolume = function (volume, callback = null) {
    if (that.isGameing && that.isGameOperateMic) {
      message.warning('游戏中无法调节麦克风音量');
      callback && callback(false);
      return;
    }
    that.mic_state = true;
    that.speakVolume = volume;
    Util.setCookie('speakVolume', volume);
    window.eleEvents.setAudioRecordingVolume(volume);
    callback && callback(true);
  };
  //解除禁言
  that.changeRoleToPlayer = function () {
    window.eleEvents.enableLocalAudio(false);
    that.published = true;
    that.disAudio = false;
  };
  //被禁言
  that.changeRoleToAudience = function () {
    window.eleEvents.enableLocalAudio(true);
    that.published = false;
    that.disAudio = true;
  };
  //上麦
  that.publishLocalStream = function (queue) {
    if (that.slefStream) return;
    return new Promise((resolve, reject) => {
      that.index = queue.index;
      if (that.mic_list.length == 0) {
        that.room.closeLoading && that.room.closeLoading();
        message.error(
          '未检出到你的电脑上有麦克风设备，请检查正确安装/打开后再试。'
        );
        reject();
      } else {
        that.slefStream = true;
        window.eleEvents.setClientRole(1).then(function () {
          that.localStream = true;
          that.mic_state = true;
          if (that.index == 0) {
            getLiveConfig().then(function () {
              joinSuccess();
            });
          } else {
            joinSuccess();
          }
          resolve();
          //开启麦克风
          that.room.events['CHANGE_MIC_STATE'] &&
            that.room.events['CHANGE_MIC_STATE'](true, that.speakVolume);
          //上麦标注
          that.room.events['CHANGE_UPINMIC_STATE'] &&
            that.room.events['CHANGE_UPINMIC_STATE'](true);
          //播放器参数初始化
          if (that.room.events['INIT_LOCAL_MUSIC_PARAM']) {
            that.room.events['INIT_LOCAL_MUSIC_PARAM']({
              audioModal: that.audioModal,
              audioVolume: that.audioVolume,
            });
          }
        });
      }
    });
  };
  //下麦
  that.delToMic = function (n) {
    //下麦标注
    that.room.events['CHANGE_UPINMIC_STATE'] &&
      that.room.events['CHANGE_UPINMIC_STATE'](false);
    //关闭存在本地流
    if (that.localStream) {
      window.eleEvents.setClientRole(2).then(function () {
        that.published = false;
        that.localStream = null;
        that.slefStream = false;
      });
    }
    //删除自己的队列
    if (that.room.hasQueume()) {
      const { microType } = store.getState();
      if (microType === 0) {
        that.room.queuePoll(that.room.account);
      } else {
        HTTP._post_server_down_microphone({
          roomId: that.room.roomid,
          operationType: 0,
        });
      }
    }
    that.room.events['CHANGE_MIC_GAME_OVER'] &&
      that.room.events['CHANGE_MIC_GAME_OVER'](n);
  };
  //销毁离开房间
  that.destroyRoom = function (n) {
    that.room.webrtc = null;
    that.delToMic(3);
    //离开房间
    window.eleEvents.leaveChannel().then(
      function () {
        console.log('destroyRoom：', n);
        that.joined = false;
        that.localStream = null;
        that.remoteStreams = [];
        that.isAgoraRTC = false;
      },
      function () {
        console.log('destroyRoom error：', n);
        that.joined = false;
        that.localStream = null;
        that.remoteStreams = [];
        that.isAgoraRTC = false;
      }
    );
  };
  /**
   * 设置变声
   * @param {0} 关闭
   * @param {33686272} 男孩
   * @param {33686784} 女孩
   * @param {33687296} 绿巨人
   * @param {33686016} 老男孩
   * @param {33687040} 猪八戒
   * @param {33686528} 少女
   * @param {33685760} 大叔
   * @returns
   */
  that.setAudioEffectPreset = function (value) {
    if (window.eleEvents && window.eleEvents.setAudioEffectPreset) {
      return window.eleEvents.setAudioEffectPreset(value);
    } else {
      return new Promise(function (resolve, reject) {
        reject({
          code: 1,
          message: '客户端版本未升级',
        });
      });
    }
  };
  /**
   * 设置美声音效
   * @param {0} 关闭
   * @param {16843264} 清新（女）
   * @param {16843008} 磁性（男）
   * @param {16843520} 活力（女）
   * @param {16908544} 歌唱美声
   * @param {16975360} 清澈
   * @param {16974336} 低沉
   * @param {16974848} 假音
   * @param {16975104} 饱满
   * @param {16974592} 圆润
   * @param {16975616} 高亢
   * @param {16975872} 嘹亮
   * @param {16974080} 浑厚
   * @returns
   */
  that.setVoiceBeautifierPreset = function (value) {
    if (window.eleEvents && window.eleEvents.setAudioEffectPreset) {
      return window.eleEvents.setAudioEffectPreset(value);
    } else {
      return new Promise(function (resolve, reject) {
        reject({
          code: 1,
          message: '客户端版本未升级',
        });
      });
    }
  };
  /**
   * 设置本地语音音调。
   */
  that.setLocalVoicePitch = function (value) {
    if (window.eleEvents && window.eleEvents.setLocalVoicePitch) {
      return window.eleEvents.setLocalVoicePitch(value);
    } else {
      return new Promise(function (resolve, reject) {
        reject({
          code: 1,
          message: '客户端版本未升级',
        });
      });
    }
  };
  /**
   * 设置本地语音音效均衡。
   */
  that.setLocalVoiceEqualization = function (value1, value2) {
    if (window.eleEvents && window.eleEvents.setLocalVoiceEqualization) {
      return window.eleEvents.setLocalVoiceEqualization(value1, value2);
    } else {
      return new Promise(function (resolve, reject) {
        reject({
          code: 1,
          message: '客户端版本未升级',
        });
      });
    }
  };

  /***
   * 游戏方操作闭麦开麦
   * */
  that.gameOperateRTC = {
    syncGameStatus: (bool = false) => {
      that.isGameing = bool;
      if (!bool) {
        that.isGameOperateMic = false;
        that.isGameOperateSpeaker = false;
      }
    },
    // 开麦
    openMicrophone: () => {
      if (that.client && that.isGameing && that.localStream) {
        that.isGameOperateMic = true;
        that.changeMicState({ open: true, operateSource: true });
      }
    },
    // 闭麦
    closeMicrophone: () => {
      if (that.client && that.isGameing && that.localStream) {
        that.isGameOperateMic = true;
        that.changeMicState({ open: false, operateSource: true });
      }
    },
    // 开启扬声器
    openSpeaker: () => {
      if (that.client && that.isGameing) {
        that.isGameOperateSpeaker = true;
        that.changeVoiceState({ open: true, operateSource: true });
      }
    },
    // 关闭扬声器
    closeSpeaker: () => {
      if (that.client && that.isGameing) {
        that.isGameOperateSpeaker = true;
        that.changeVoiceState({ open: false, operateSource: true });
      }
    },
  };
  return that;
})();
export default ERTC;
